module.exports = __webpack_public_path__ + "img/expert.9af18819.png";